import type { ActiveSession } from '../shared/types';
import { pointerForExercise } from '../shared/engine';

export function appendSessionSet(session: ActiveSession, slotId: string): ActiveSession {
  if (!['active','partial'].includes(session.status ?? 'active')) throw new Error('This workout is closed.');
  const item=session.template.exercises.find(entry=>entry.id===slotId);
  if (!item || item.sets>=20) throw new Error('Maximum 20 sets per exercise.');
  const logged=new Set(session.sets.filter(set=>set.templateExerciseId===slotId).map(set=>set.setNumber));
  const firstMissing=Array.from({length:item.sets},(_,index)=>index+1).find(number=>!logged.has(number));
  const template={...session.template,exercises:session.template.exercises.map(entry=>entry.id===slotId?{...entry,sets:entry.sets+1,finishedEarly:false}:entry)};
  const pointer=firstMissing===undefined
    ? pointerForExercise(template,slotId,item.sets+1)
    : item.finishedEarly ? pointerForExercise(template,slotId,firstMissing) : session.pointer;
  if(!pointer) throw new Error('Exercise unavailable.');
  return {...session,template,pointer,finalSetAt:null,elapsedSeconds:null};
}
